import { useContext, useEffect } from "react";

import {Loading} from 'components';

import { useNavigate, useParams } from 'react-router';
import { AuthContext } from "@panamod/react-utils";

export const Component = () => {
	const { isLogged, handleValidarOTP, handleCerrarSesion } = useContext(AuthContext)
	const { otp } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLogged) {
			navigate('/', { replace: true });
			return;
		}

		if (!otp || otp === 'undefined') {
			handleCerrarSesion();
			return;
		}

		const [cDeviceToken, cOTP] = otp.split('-');
		handleValidarOTP(cOTP || '', cDeviceToken || '');
	}, [otp, isLogged]);

	return (<Loading />);
}

export { Component as ValidarOTP }